import React from 'react';
import { Segment } from 'semantic-ui-react';
import { Button } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

export default function ButtonGroup({ onNew, onReset, onTrigger }) {
    return (
        <Segment basic textAlign="right">
            {onNew ? (
                <Button primary onClick={onNew} style={{ marginLeft: '10px' }}>
                    <Trans i18nKey="nacre.ImportController.buttons.import_new">Import a new file</Trans>
                </Button>
            ) : null}
            {onReset ? (
                <Button onClick={onReset} style={{ marginLeft: '10px' }}>
                    <Trans i18nKey="ticket.common.action.cancel">Cancel</Trans>
                </Button>
            ) : null}
            {onTrigger ? (
                <Button primary onClick={onTrigger} style={{ marginLeft: '10px' }}>
                    <Trans i18nKey="ticket.common.action.import">Import</Trans>
                </Button>
            ) : null}
        </Segment>
    );
}

ButtonGroup.propTypes = {
    onNew: PropTypes.func,
    onReset: PropTypes.func,
    onTrigger: PropTypes.func
};
